import * as React from 'react';

import { Form } from 'antd';
import { Column, Modal, Row, Space, Text } from 'farmhub-ui-core';
import styled, { css } from 'styled-components';

import {
  dataEmpty,
  Empty,
  NameText,
  SearchTable,
  Table,
  TitleText,
} from 'components';
import { EmptyDiv } from 'styled';
import {
  OPTION_TYPE_STRING,
  getDummyArray,
  renderTableSkeleton,
  removeVietnameseTones,
  paginationInit,
} from 'utils';

import UpdateOptionInput from '../CreateTagModal/components/UpdateOptionInput';

interface CreateTagModalProps {
  isVisible: boolean;
  id?: string;
  name?: string;
  type: 'PRODUCT' | 'ORDER' | 'ENTITY';
  initOptions: any[];
  setIsVisible: (e: boolean) => void;
}

const TableStyle = css`
  .ant-table-cell {
    div:first-child {
      margin-bottom: 0px;
    }
  }
`;

const ModalStyled = css`
  .ant-modal-body {
    padding: 12px !important;
  }
`;

const ViewTagModal = ({
  isVisible,
  id,
  name,
  type,
  initOptions,
  setIsVisible,
}: CreateTagModalProps): JSX.Element => {
  const [form] = Form.useForm();
  const [searchValue, setSearchValue] = React.useState<string>('');
  const [totalCreated, setTotalCreated] = React.useState(0);
  const [selectedOptions, setSelectedOptions] =
    React.useState<any[]>(initOptions);
  const [pagination, setPagination] = React.useState(paginationInit);
  const [isLoading, setIsLoading] = React.useState(false);
  const [currentOption, setCurrentOption] = React.useState<any[]>(
    () => initOptions
  );

  const handleClear = (): void => {
    form.resetFields();
    setSelectedOptions([]);
    setTotalCreated(0);
  };

  const handleCancel = (): void => {
    setIsVisible(false);
    handleClear();
  };

  const handlePaginationChange = e => {
    setPagination(prevState => {
      return {
        ...prevState,
        current: e.current,
      };
    });
  };

  const handleSearch = (value): void => {
    if (value) {
      const result = initOptions.filter(item =>
        removeVietnameseTones(item?.content?.toLowerCase() || '').includes(
          removeVietnameseTones(value.toLowerCase() || '')
        )
      );

      setCurrentOption(result);
      setPagination(prevData => {
        return {
          ...prevData,
          current: 1,
        };
      });
    } else {
      setCurrentOption(initOptions);
    }
  };

  const columns: Array<any> = [
    {
      width: 320,
      title: <NameText>Tên nhãn</NameText>,
      key: 'option',
      render: (option: any) => (
        <UpdateOptionInput isEditing={false} option={option} />
      ),
    },
  ];

  React.useEffect(() => {
    const initData = () => {
      setSelectedOptions(initOptions);

      if (searchValue) {
        handleSearch(searchValue);
      } else {
        setCurrentOption(initOptions);
      }
    };

    if (isVisible) {
      initData();
    }
  }, [isVisible, initOptions]);

  return (
    <EmptyDiv onClick={e => e.stopPropagation()}>
      <Modal
        centered
        destroyOnClose
        bodyHeight="650px"
        styles={ModalStyled}
        title={
          <TitleText>
            Danh sách nhãn {OPTION_TYPE_STRING[type].vi}{' '}
            <Text color="main" weight="extraBold">
              {name}
            </Text>
          </TitleText>
        }
        visible={isVisible}
        width="520px"
        onCancel={handleCancel}
      >
        <Row justifyContent="space-between">
          <Row width="200px">
            <Space width={10}> </Space>
            <NameText color="primary" lineHeight="22px">
              Danh sách nhãn ({initOptions?.length})
            </NameText>
          </Row>
          <Column alignItems="flex-end">
            <SearchTable
              height="sm"
              placeholder="Tìm kiếm nhãn"
              value={searchValue}
              width={220}
              onChange={e => setSearchValue(e.target.value)}
              onEnter={e => handleSearch(e.target.value)}
            />
          </Column>
        </Row>

        <Table
          columns={isLoading ? renderTableSkeleton(tableSkeleton) : columns}
          dataSource={isLoading ? getDummyArray(10) : [...currentOption]}
          locale={{
            emptyText: (
              <>
                <Space height={24} />
                <Empty
                  description="Hiện tại không có nhãn"
                  img={dataEmpty.COMMENT}
                  minHeight={120}
                />
              </>
            ),
          }}
          pagination={{
            ...pagination,
            total: pagination.total + totalCreated,
          }}
          rowKey="id"
          styles={TableStyle}
          onChange={handlePaginationChange}
        />
      </Modal>
    </EmptyDiv>
  );
};

export default ViewTagModal;

const tableSkeleton = [
  {
    width: 320,
    title: 'Tên nhãn',
    type: 'input',
  },
  {
    width: 50,
    type: 'input',
  },
];
